import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_DML_DOCUMENT_STATUS} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const  DMLDocumentStatus = lazy(() =>
  import('../../../screens/DMLDocumentStatus')
    .then(module => ({default: module.DMLDocumentStatus})));

const DMLDocumentStatusNavigation = [
  {
    path: ROUTE_DML_DOCUMENT_STATUS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <DMLDocumentStatus />
      </Suspense>
    ),
  },
];

export default DMLDocumentStatusNavigation;
